import { timeZones } from 'lib/consts/timeZones'
import { getTodayInTimeZone } from 'lib/helpers/getTodayInTimeZone/getTodayInTimeZone'

/** Floating `yyyy-MM-dd` for the Pacific day. `useOperationalToday` owns Date conversion. */
export const getPacificToday = () => getTodayInTimeZone({ timeZone: timeZones.pacific })
